import React from 'react';

import classNames from 'classnames';

import { GROUP_START_CELL } from './helpers/reportRowStyles';

// The header is two dark bands: the lighter one groups the columns by time base,
// the darker one names each column. Both are needed because the column labels are
// deliberately short ("Budget", "Actuals", "Variance" repeat across the three
// time bases) and only the band above them says which period they cover.
//
// One styling for every report level. The metrics (padding, alignment, weight)
// come from tables/_avb-report.scss, which only reaches `.avb-report-table` — so
// any table rendering these rows must carry that class or the shared dense-grid
// style in tables/_style.scss takes over.
const STYLES = {
    group: '!tw-bg-charcoal-85 !tw-text-white tw-text-[11px] avb-report-table__group',
    groupLabel: 'tw-min-w-56',
    column: '!tw-bg-charcoal !tw-text-white tw-font-medium tw-text-xs',
    columnLabel: 'tw-min-w-56',
};

// Comparison-version columns are pulled out of the report version's own columns
// with the app's navy accent, matching the tint their cells carry.
const COMPARISON_CELL = '!tw-bg-dark-blue';

/**
 * Top band: one cell per column group, spanning that group's visible columns.
 */
export const ReportGroupHeaderRow = ({ groups }) => (
    <tr>
        {groups.map((group) => (
            <th
                key={group.key}
                className={classNames(STYLES.group, {
                    [STYLES.groupLabel]: group.isLabel,
                    [GROUP_START_CELL]: !group.isLabel,
                })}
                colSpan={group.colSpan || 1}
            >
                {group.text}
            </th>
        ))}
    </tr>
);

/**
 * Bottom band: the column labels, with the row-label column carrying the
 * hierarchy it describes.
 */
export const ReportColumnHeaderRow = ({ columns }) => (
    <tr>
        {columns.map((column) => (
            <th
                key={column.key}
                className={classNames(STYLES.column, {
                    [STYLES.columnLabel]: column.isLabel,
                    'tw-min-w-28': !!column.month,
                    'tw-min-w-14': column.percentage,
                    'tw-min-w-36': !column.isLabel && !column.month && !column.percentage,
                    [COMPARISON_CELL]: column.comparison,
                    [GROUP_START_CELL]: column.groupStart,
                })}
            >
                {column.text}
            </th>
        ))}
    </tr>
);
